"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var NoDataPlaceholder_meta_1 = require("./NoDataPlaceholder.meta");

var NoDataPlaceholder =
/** @class */
function (_super) {
  __extends(NoDataPlaceholder, _super);

  function NoDataPlaceholder(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = NoDataPlaceholder_meta_1.NO_DATA_PLACEHOLDER_CATEGORY_KEY;
    _this.componentKey = NoDataPlaceholder_meta_1.NO_DATA_PLACEHOLDER_COMPONENT_KEY;
    return _this;
  }

  NoDataPlaceholder.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, children);
  };

  NoDataPlaceholder = __decorate([mobx_react_1.observer], NoDataPlaceholder);
  return NoDataPlaceholder;
}(shared_1.ComponentBase);

exports.NoDataPlaceholder = NoDataPlaceholder;
exports.default = shared_1.InjectedStyledComponent(NoDataPlaceholder, NoDataPlaceholder_meta_1.NO_DATA_PLACEHOLDER_CATEGORY_KEY, NoDataPlaceholder_meta_1.NO_DATA_PLACEHOLDER_COMPONENT_KEY);